import { ReactElement, useEffect, useState } from "react";
import { AuthContext, AuthMethod, AuthMethodType } from "./AuthContext";
import Cookies from "js-cookie";
import { useQueryParams } from "utils/useQueryParams";
import jwt from "jsonwebtoken";

type AuthProviderProps = {
  children: ReactElement;
};
export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState<string | undefined>();
  const [mwtCode, setMwtCode] = useState<string | undefined>();
  const [authMethod, setAuthMethod] = useState<AuthMethodType | undefined>();

  const isAuthenticated = !!authMethod;

  const queryMwtCode = useQueryParams("mwt_code") as string | null;

  useEffect(() => {
    const mwt = sessionStorage.getItem("MWT");
    if (mwt) {
      const claims = jwt.decode(mwt);
      setAuthMethod(claims?.type as AuthMethodType);
      setToken(mwt);
    } else if (Cookies.get("authorization")) {
      setToken(Cookies.get("authorization"));
      setAuthMethod(AuthMethod.COOKIE);
    } else if (queryMwtCode) {
      setAuthMethod(AuthMethod.MWT_CODE);
      setMwtCode(queryMwtCode);
    }
    setIsLoading(false);
  }, [mwtCode]);

  const logout = () => {
    setToken(undefined);
    setAuthMethod(undefined);
    setMwtCode(undefined);
    sessionStorage.removeItem("MWT");
  };

  return (
    <AuthContext.Provider
      value={{
        authMethod,
        isAuthenticated,
        logout,
        setAuthMethod,
        setToken,
        token,
        isLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
